import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useGetPageContentMutation } from "../../api/services/pageContent/pageContentApi";
import { PAGE_NAME_BY_ROUTE_MAPPING } from "../../helpers/constants";
import { getMatchedPageName } from "../../helpers/utils";
import { useMediaQueries } from "../../hooks/useMediaQueries";
import {
  resetSiteCorePageContent,
  setSiteCorePageContent,
  setSiteCorePageContentLoading,
  toggleLoader,
  toggleToast,
  toggleUnmountLoader,
} from "../../redux/slices/appState/appStateSlice";
import { MuiBox } from "../box/MuiBox";
import { HeaderNotification } from "../headerNotification/HeaderNotification";
import { HeaderProfile } from "../headerProfile/HeaderProfile";
import { LanguageSelection } from "../languageSelection/LanguageSelection";
import { HamburgerMenuOpenCloseIcon } from "./HamburgerMenuOpenClose";
import { HeaderWrapper } from "./Header.style";
import { HeaderCompanyLogo } from "./HeaderCompanyLogo";

export const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isSmallScreen } = useMediaQueries();
  const {
    mutateAsync: getPageContent,
    isPending: isPageContentPending,
    isError,
  } = useGetPageContentMutation();

  const setApiData = async (pageName: string) => {
    const response = await getPageContent(pageName);
    dispatch(setSiteCorePageContent(response));
  };

  useEffect(() => {
    dispatch(toggleUnmountLoader());
    const matchedPageKey = getMatchedPageName(
      location.pathname,
      PAGE_NAME_BY_ROUTE_MAPPING,
    );
    if (matchedPageKey) {
      const matchedPageName = PAGE_NAME_BY_ROUTE_MAPPING[matchedPageKey];
      dispatch(resetSiteCorePageContent());
      setApiData(matchedPageName);
    }
  }, [location]);

  useEffect(() => {
    dispatch(setSiteCorePageContentLoading(isPageContentPending));
    return () => {
      dispatch(setSiteCorePageContentLoading(false));
    };
  }, [isPageContentPending]);

  useEffect(() => {
    if (isError) {
      dispatch(
        toggleToast({
          open: true,
          message: "Oops, something went wrong...!",
          type: "error",
        }),
      );
      dispatch(toggleLoader({ isVisible: false }));
    }
  }, [isError]);

  return (
    <header role="banner">
      <HeaderWrapper data-testid="app-header">
        <MuiBox className="left">
          {isSmallScreen && <HamburgerMenuOpenCloseIcon />}
          <HeaderCompanyLogo />
        </MuiBox>
        <MuiBox className="right">
          <HeaderNotification />
          <LanguageSelection />
          <HeaderProfile />
        </MuiBox>
      </HeaderWrapper>
    </header>
  );
};
